import React, { FunctionComponent } from "react";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import cs from "classnames";
import { useTranslation } from "react-i18next";
import {
  ChallengeFormula,
  instanceOfDsqRecord,
  instanceOfTeamRecord,
} from "/src/domain/challenges/ChallengeProtocolData";
import { getValueLabel } from "/src/utils/protocol-utils";

export interface ProtocolHeaderContentProps {
  className?: string;
  isTimeRace: boolean;
  mainRaceLabel?: string;
  challengeType: ChallengeFormula;
}

export const ProtocolHeaderContent: FunctionComponent<
  ProtocolHeaderContentProps
> = ({ className, isTimeRace, mainRaceLabel }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid
      container
      className={cs(classes.header, className)}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item container xs={11} spacing={1}>
        <Grid item xs={1}></Grid>
        <Grid
          item
          xs={1}
          container
          justifyContent="center"
          style={{ paddingLeft: 0 }}
          className={classes.headerCell}
        >
          #
        </Grid>
        <Grid item xs={8} className={classes.headerCell}>
          {t("name")}
        </Grid>
        <Grid
          item
          container
          xs={2}
          justifyContent="flex-end"
          className={classes.headerCell}
        >
          {isTimeRace ? t("time") : t(mainRaceLabel!!)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export const DsqHeaderContent: FunctionComponent<
  ProtocolHeaderContentProps
> = ({ className }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid
      container
      className={cs(classes.header, className)}
      justifyContent="center"
      alignItems="center"
      spacing={1}
    >
      <Grid item xs={1} className={classes.headerCell}></Grid>
      <Grid item xs={3} sm={2} className={classes.headerCell}>
        {t("activityId")}
      </Grid>
      <Grid item xs={3} sm={4} className={classes.headerCell}>
        {t("name")}
      </Grid>
      <Grid item xs={4} className={classes.headerCell}>
        {t("comment")}
      </Grid>
    </Grid>
  );
};

export const TeamHeaderContent: FunctionComponent<
  ProtocolHeaderContentProps
> = ({ className, challengeType }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      className={cs(classes.header, className)}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item container xs={11} spacing={1}>
        <Grid item xs={1}></Grid>
        <Grid
          item
          xs={1}
          container
          justifyContent="center"
          style={{ paddingLeft: 0 }}
          className={classes.headerCell}
        >
          #
        </Grid>
        <Grid item xs={6} className={classes.headerCell}>
          {t("location")}
        </Grid>
        <Grid
          item
          container
          xs={4}
          justifyContent="flex-end"
          className={classes.headerCell}
        >
          {t(getValueLabel(challengeType) || "")}
        </Grid>
      </Grid>
    </Grid>
  );
};

export const getHeaderContentClassByRecord = (record: any) => {
  if (instanceOfTeamRecord(record)) {
    return TeamHeaderContent;
  }
  if (instanceOfDsqRecord(record)) {
    return DsqHeaderContent;
  }

  return ProtocolHeaderContent;
};

const useStyles = makeStyles((muiTheme) => ({
  container: {},
  headerCell: {
    overflowX: "auto",
  },
  header: {
    width: "100%",
    margin: 0,
    height: "2.5rem",
    marginTop: "0.5rem",
    fontSize: "0.9rem",
    fontWeight: 500,
    color: muiTheme.palette.primary.main,
    padding: "0.5rem 0",
  },
}));
